// extracted by mini-css-extract-plugin
export var link = "Breadcrumb-module--link--55604";
export var root = "Breadcrumb-module--root--1fe27";
export var seperator = "Breadcrumb-module--seperator--bc3d7";